import { FilterCondition, FilterDTO, FilterOperator, Role, SortDirection } from './../../models/models.swagger.generated';
import { AuthService } from '../auth.service';
import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { ClientClient, ClientDTO, PagedResultDTOOfClientDTO } from 'src/app/base/models/models.swagger.generated';
import { catchError, finalize, tap } from 'rxjs/operators';
import { ToastService } from 'src/app/base/services/toast.service';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { ErrorType } from 'src/app/core/routing/error-types';
import { IAdaptorService } from '../../shared/syncfusion/adaptor-service.interface';
import { IPagedItems } from '../../shared/syncfusion/paged-items.interface';

@Injectable({
  providedIn: 'root',
})
export class ClientService implements IAdaptorService {

  public clients: ClientDTO[] = [];
  public numberOfClients: number;

  constructor(
    private authService: AuthService,
    private clientAdministrationClient: ClientClient,
    private toastService: ToastService,
    private spinnerService: SpinnerService,
  ) {
  }

  getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<IPagedItems> {
    return this.getAccessibleClients(filters, skip, take);
  }

  addRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  updateRecord(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  deleteRecord(id: number): Observable<any> {
    throw new Error('Method not implemented.');
  }

  public getAccessibleClients(filter: FilterDTO[] = null, skip = 0, take = 20, hasImportConfiguration?: boolean | null, hasExportConfiguration?: boolean | null): Observable<PagedResultDTOOfClientDTO> {
    const loggedInUser = this.authService.getUserInfo();
    // avoid error message during user administration for asset admin or asset storage admin
    if (!loggedInUser || this.authService.doesUserHaveAnyRole([Role.AssetStorageAdmin, Role.AssetStorageLimitedAdmin])) {
      return of(null);
    }
    if (loggedInUser.client) {
      // this.selectedClient = loggedInUser.client;
      this.clients = [loggedInUser.client];
      return of({
        items: [loggedInUser.client],
        totalNumberOfItems: 1,
      } as PagedResultDTOOfClientDTO);
    } else {
      this.spinnerService.show();

      if (filter == null) {
        filter = [new FilterDTO({isComplex: false, field: 'IsActive', operator: FilterOperator.Equal, value: 'true'})];
      }
      return this.clientAdministrationClient.searchClients(skip, take, 'name', SortDirection.Ascending, hasImportConfiguration ?? undefined, hasExportConfiguration ?? undefined, filter)
        .pipe(
          tap((pagedResult: PagedResultDTOOfClientDTO) => {
            this.clients = pagedResult.items;
            this.numberOfClients = pagedResult.totalNumberOfItems;
          }),
          finalize(() => this.spinnerService.hide()),
          catchError((error: any) => {
            if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
              this.toastService.showError('i18n.errors.server-error.title',
                'i18n.errors.server-error.message', null, ErrorType.serverError);
            }
            return of(error);
          }),
        );
    }
  }

  public searchClients(searchTerm: string, take: number, hasImportConfiguration?: boolean | null, hasExportConfiguration?: boolean | null): Observable<PagedResultDTOOfClientDTO> {
    const filters = [new FilterDTO({isComplex: false, field: 'IsActive', operator: FilterOperator.Equal, value: 'true'})];
    searchTerm = searchTerm?.trim();
    if(searchTerm != null && searchTerm.length) {
      filters.push( new FilterDTO({
        isComplex: true,
        condition: FilterCondition.Or,
        predicates: [
          new FilterDTO({isComplex: false, field: 'Name', operator: FilterOperator.Contains, value: searchTerm}),
          new FilterDTO({isComplex: false, field: 'CustomerNumber', operator: FilterOperator.Contains, value: searchTerm}),
          new FilterDTO({isComplex: false, field: 'VendorNumber', operator: FilterOperator.Contains, value: searchTerm})
        ]
      }));
    }

    return this.getAccessibleClients(filters, 0, take, hasImportConfiguration, hasExportConfiguration);
  }

  public getClientById(id: number) {
    const filters = [new FilterDTO({isComplex: false, field: 'IsActive', operator: FilterOperator.Equal, value: 'true'}),
                     new FilterDTO({isComplex: false, field: 'Id', operator: FilterOperator.Equal, value: id.toString()}),];
    return this.getAccessibleClients(filters, 0, 1);
  }
}
